<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('scope.text_712')}}</div>
    <div slot="body">
      <a-form
        :form="form.fc">
        <a-form-item :label="$t('scope.text_713')" v-bind="formItemLayout">
          <list-select
            v-decorator="decorators.bill_id"
            :list-props="billProps"
            :formatter="billFormatter"
            :placeholder="$t('scope.text_714')" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_715')" v-bind="formItemLayout">
          <list-select
            v-decorator="decorators.invoice_info_id"
            :list-props="invoiceInfoProps"
            :formatter="invoiceInfoFormatter"
            :multiple="false"
            :placeholder="$t('scope.text_716')" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_717')" v-bind="formItemLayout">
          <list-select
            v-decorator="decorators.invoice_address_id"
            :list-props="invoiceAddressProps"
            :formatter="invoiceAddressFormatter"
            :multiple="false"
            :placeholder="$t('scope.text_718')" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import BillPropsMixin from '../mixins/billProps'
import InvoiceInfoPropsMixin from '../mixins/invoiceInfoProps'
import InvoiceAddressPropsMixin from '../mixins/invoiceAddressProps'
import { numerify } from '@/filters'
import ListSelect from '@/sections/ListSelect'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'CreateInvoiceApplicationDialog',
  components: {
    ListSelect,
  },
  mixins: [DialogMixin, WindowsMixin, BillPropsMixin, InvoiceInfoPropsMixin, InvoiceAddressPropsMixin],
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      decorators: {
        bill_id: [
          'bill_id',
          {
            rules: [
              { required: true, message: this.$t('scope.text_714') },
            ],
          },
        ],
        invoice_info_id: [
          'invoice_info_id',
          {
            rules: [
              { required: true, message: this.$t('scope.text_716') },
            ],
          },
        ],
        invoice_address_id: [
          'invoice_address_id',
          {
            rules: [
              { required: true, message: this.$t('scope.text_718') },
            ],
          },
        ],
      },
    }
  },
  methods: {
    billFormatter (val) {
      return this.$t('scope.text_719', [val.id], numerify(val.paid_amount, '0,0.00'))
    },
    invoiceInfoFormatter (val) {
      const obj = {
        ordinary: this.$t('scope.text_721'),
        special: this.$t('scope.text_722'),
        ngo: this.$t('scope.text_723'),
      }
      return this.$t('scope.text_724', [val.title, obj[val.invoice_type]])
    },
    invoiceAddressFormatter (val) {
      const text = val.province + val.city + val.district + val.street + val.address
      return this.$t('scope.text_725', [text])
    },
    doCreate (data) {
      return this.params.onManager('create', {
        managerArgs: {
          data,
        },
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        const { data: { data = [] } } = await new this.$Manager('billing_accounts').list()
        const params = {
          ...values,
          currency: 'CNY',
          name: 'commonlyused',
          billing_account_id: data[0].id,
        }
        const res = await this.doCreate(params)
        await this.params.onManager('performAction', {
          id: res.data.id,
          managerArgs: {
            action: 'submit',
          },
        })
        this.loading = false
        this.cancelDialog()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
